import { render, staticRenderFns } from "./PanoramaMaterialKind.vue?vue&type=template&id=7d6e5ce2&scoped=true&"
import script from "./PanoramaMaterialKind.vue?vue&type=script&lang=js&"
export * from "./PanoramaMaterialKind.vue?vue&type=script&lang=js&"
import style0 from "./PanoramaMaterialKind.vue?vue&type=style&index=0&id=7d6e5ce2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6e5ce2",
  null
  
)

export default component.exports